import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../ForgotPassword/ForgotPassword.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleForgotPassword = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch("https://api.hgcdental.clinic/forgot-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            setMessage(data.message);

            if (response.ok) {
                navigate("/verify-otp", { state: { email } });
            }
        } catch (error) {
            setMessage("No Such User. Please try again.");
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-container form">
                <div className="signup-card-1">
                    <h2>Forgot Password</h2>
                    <p>Enter your email to receive a password reset OTP.</p>

                    <form onSubmit={handleForgotPassword}>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit">Send OTP</button>
                    </form>

                    {/* Back/Cancel Button */}
                    <button className="cancel-button" onClick={() => navigate("/login")}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
